import { render, staticRenderFns } from "./SectionProduct.vue?vue&type=template&id=76e1ccda"
import script from "./SectionProduct.vue?vue&type=script&lang=ts"
export * from "./SectionProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports